import React, { useState, useContext, useEffect } from "react";
import { ProductContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "./Header";
import { getCachedData, setCachedData } from "../utils/apiCache";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";

import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Modal,
  Form,
} from "react-bootstrap";
import Swal from "sweetalert2";

function Feedback() {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const routes = all_routes;

  const [formData, setFormData] = useState({
    category: "",
    subject: "",
    description: "",
  });
  const [studentId, setStudentId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [success, setSuccess] = useState(false);




  // Modal
  const [showModal, setShowModal] = useState(false);
  const [showModalView, setShowModalView] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");

  const authtoken = localStorage.getItem("token");
  const navigate = useNavigate();
  const { userId, setClassSectionId, GetstudentData } =
    useContext(ProductContext);

  const StudentId = GetstudentData?.id;
  const SelectClassId = GetstudentData?.class_section_id;

  // Time ago function
  const timeAgo = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diff = Math.floor((now - past) / 1000);
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 2592000) return `${Math.floor(diff / 86400)}d ago`;
    return past.toLocaleDateString("en-GB");
  };

  const openFileModal = (url) => {
    setSelectedFile(url);
    setShowModalView(true);
  };

  useEffect(() => {
    if (!userId) return;

    const fetchStudentId = async () => {
      try {
        const response = await fetch(
          `https://api.mirai.healthcare/api/student?regs_id=${userId}`,
          {
            headers: { "x-auth": authtoken },
          }
        );
        const data = await response.json();
        if (data.success && data.message.length > 0) {
          const studentData = data.message[0];
          setStudentId(studentData.id);
          setClassSectionId(studentData.class_section_id);
        }
      } catch (error) {
        console.error("Error fetching student ID:", error);
      }
    };

    const fetchCategories = async () => {
      console.log("Fetching categories...");
      try {
        const response = await fetch("https://api.mirai.healthcare/api/masters/complaint", {
          headers: {
            "x-auth": authtoken,
          },
        });
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchStudentId();
    fetchCategories();
  }, [userId]);


  const fetchFeedbacks = async () => {
    if (!StudentId) return;
    const cacheKey = `feedbacks_${StudentId}`;
    const cached = getCachedData(cacheKey);
    if (cached) {
      setFeedbacks(cached);
      setLoading(false);

    }
    try {
      const response = await axios.get(
        `https://api.mirai.healthcare/api/head/feedback?student_id=${StudentId}`,
        {
          headers: { "x-auth": authtoken },
        }
      );
      const data = response?.data?.data || [];
      const sorted = data.sort(
        (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
      setFeedbacks(sorted);
      setCachedData(cacheKey, sorted);
    } catch (err) {
      console.error("Error fetching feedback:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchFeedbacks();
  }, [StudentId, authtoken]);

  const paginatedFeedbacks = feedbacks.slice(0, page * pageSize);
  const hasMore = feedbacks.length > paginatedFeedbacks.length;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "open": return "bg-success";
      case "escalated": return "bg-warning text-dark";
      case "closed": return "bg-secondary";
      default: return "bg-light text-dark border";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const activeStudentId = studentId || StudentId;
      if (!activeStudentId) throw new Error("Student ID is not available.");

      const formDataToSend = new FormData();
      formDataToSend.append("student_id", activeStudentId.toString());
      formDataToSend.append("category", formData.category.toString());
      formDataToSend.append("subject", formData.subject);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("created_by", activeStudentId.toString());

      if (SelectClassId) {
        formDataToSend.append("cls_sec_id", SelectClassId.toString());
      }

      if (file) {
        formDataToSend.append("file", file);
      }

      const response = await fetch("https://api.mirai.healthcare/api/head/feedback", {
        method: "POST",
        headers: { "x-auth": `${authtoken}` },
        body: formDataToSend,
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.message || "Failed to submit feedback");

      setSuccess(true);
      Swal.fire({ title: "Success", text: "Feedback submitted!", icon: "success" });

      setShowModal(false);

      setFormData({ category: "", subject: "", description: "" });
      setFile(null);
      setFilePreview(null);

      fetchFeedbacks();
    } catch (error) {
      Swal.fire({ title: "Error", text: error.message || "Failed to submit feedback", icon: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper min-vh-100">
      <Header />

      <div className="content px-4 pt-5">
        {/* Page Header */}
        <div className="row">
          <div className="col-md-8">
            <div className="text-left mb-4">
              <h2 className="page-title fw-bold mb-0">
                E-Feedback & Chats
              </h2>
              <p className="text-muted">Track your submitted feedback and chat with admin</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="text-end mb-4">
              {/* <Link to = {routes?.addefeedback}> */}
              <button className="btn btn-primary" onClick={(() => { setShowModal(true) })} >Add E-Feedback</button>
              {/* </Link> */}
            </div>
          </div>
        </div>



        <div className="card border-0 shadow-sm">
          <div className="card-header bg-white border-0 pb-0">
            <h4 className="mb-0">
              Feedback Timeline
            </h4>
          </div>

          <div className="card-body py-4">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : feedbacks.length === 0 ? (
              <div className="text-center py-5">
                <i className="ti ti-message-off text-muted display-1"></i>
                <h5 className="mt-3 text-muted">No Feedback Found</h5>
                <p>You haven't submitted any feedback yet.</p>
              </div>
            ) : (
              <>
                <div className="timeline position-relative">
                  {paginatedFeedbacks.map((item) => (
                    <div key={item.id} className="timeline-item mb-5">
                      <div className="timeline-dot bg-primary rounded-circle">
                        <i className="ti ti-message-circle text-white"></i>
                      </div>

                      <div className="timeline-content card shadow-sm p-4 border-0 hover-lift">
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <h5 className="mb-0 text-primary">
                            {item.subject}
                          </h5>
                          <span className={`badge ${getStatusColor(item.status)}`}>
                            {item.status || "Pending"}
                          </span>
                        </div>



                        <div className="row g-3 text-muted small NewBorderTop">
                          <div className="col-md-4">
                            {item.date && (
                              <p className="mb-2">
                                <strong>Date:</strong>{" "}
                                {new Date(item.date.split("T")[0]).toLocaleDateString("en-GB", {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                })}
                              </p>
                            )}
                          </div>
                          <div className="col-md-4">
                            <p className="mb-2">
                              <strong>Submitted:</strong> {timeAgo(item.created_at)}
                            </p>
                          </div>
                          <div className="col-md-4 text-md-end">
                            {item.attach_file?.link && (
                              <span className="badge bg-info-soft text-info me-2">
                                Attachment
                              </span>
                            )}
                            {item.chat_status !== "Ended" && (
                              <button
                                onClick={() =>
                                  navigate("/chat", {
                                    state: { FeedbackId: item.id },
                                  })
                                }
                                className="btn btn-outline-primary btn-sm ms-2"
                              >
                                Chat
                              </button>
                            )}
                          </div>
                        </div>
                        {item.description && (
                          <p className="text-muted mb-3 mt-2 pt-3 line-clamp-3 NewBorderTop">
                            {item.description}
                          </p>
                        )}

                        {item.attach_file?.link && (
                          <div className="mt-3 text-end">
                            <button
                              onClick={() => openFileModal(item.attach_file.link)}
                              className="btn btn-outline-info btn-sm"
                            >
                              View Attachment
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Load More */}
                {hasMore && (
                  <div className="text-center mt-5">
                    <button
                      onClick={() => setPage(page + 1)}
                      className="btn btn-primary px-4"
                    >
                      Load More Feedback
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Attachment Modal */}
      <Modal show={showModalView} onHide={() => setShowModalView(false)} size="lg" centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title>Attachment Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {selectedFile?.endsWith(".pdf") ? (
            <iframe
              src={selectedFile}
              title="PDF Preview"
              style={{ width: "100%", height: "500px", border: "none" }}
            />
          ) : (
            <img
              src={selectedFile}
              alt="Attachment"
              className="img-fluid"
              style={{
                width: "100%",
                height: "500px",
                objectFit: "cover",
                objectPosition: "top"
              }}
            />

          )}
        </Modal.Body>
        <Modal.Footer>
          <a
            href={selectedFile}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success me-2"
          >
            Download
          </a>
          <Button variant="secondary" onClick={() => setShowModalView(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        style={{ zIndex: 1050 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Submit Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>

            <Form.Group className="mb-3">
              <Form.Label>Category</Form.Label>
              <Form.Select
                value={formData.category}
                onChange={(e) =>
                  setFormData({ ...formData, category: e.target.value }) // Set the selected category ID
                }
                required
                className="bg-white text-dark"
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.complaincategory}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>


            <Form.Group className="mb-3">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                value={formData.subject}
                onChange={(e) =>
                  setFormData({ ...formData, subject: e.target.value })
                }
                required
              />
            </Form.Group>

            {/* Description Textarea */}
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
                required
              />
            </Form.Group>

            {/* File Attachment */}
            <Form.Group className="mb-4">
              <Form.Label>Attach File (optional)</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Form.Group>

            {/* Submit Button */}
            <div className="text-end">
              <Button type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Submitting...
                  </>
                ) : (
                  "Submit Feedback"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Same Premium Styling */}
      <style jsx>{`
        .timeline {
          padding-left: 40px;
        }
        .timeline::before {
          content: "";
          position: absolute;
          left: 20px;
          top: 0;
          bottom: 0;
          width: 3px;
          background: linear-gradient(to bottom, #4361ee, #3b82f6);
          border-radius: 2px;
        }
        .timeline-item {
          position: relative;
        }
        .timeline-dot {
          position: absolute;
          left: -40px;
          top: 15px;
          width: 40px;
          height: 40px;
          background: #4361ee;
          border: 5px solid #fff;
          box-shadow: 0 0 0 4px #dbeafe;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
        }
        .timeline-content {
          border-radius: 12px;
          transition: all 0.3s ease;
        }
        .hover-lift:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 35px rgba(67, 97, 238, 0.15) !important;
        }
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .bg-info-soft {
          background-color: rgba(59, 130, 246, 0.1) !important;
          color: #3b82f6 !important;
        }
      `}</style>
    </div>
  );
}

export default Feedback;
